import { createMutationOptions, throwOnErrorResponse } from "@sg-protect/core";
import config from "@sg-protect/runtime-config";
import createFetchClient from "openapi-fetch";
import createQueryClient from "openapi-react-query";
import type { paths } from "./types.ts";

const client = createFetchClient<paths>({
    baseUrl: config.get().migrate_web.api,
    credentials: "include",
    fetch: (...args) => globalThis.fetch(...args) // Ensure that fetch is resolved at request time for Honeycomb instrumentation to work correctly
});

client.use(throwOnErrorResponse());

const { queryOptions, useMutation, useQuery, useSuspenseQuery } = createQueryClient(client);

const mutationOptions = createMutationOptions(client);

export { client, mutationOptions, queryOptions, useMutation };

/**
 * @knipignore Not consumed yet, but exported for parity with the query client shape used by the other move client.
 */
export { useQuery, useSuspenseQuery };
